var map = {
	"./symbol_0.png": "32b8",
	"./symbol_1.png": "6446",
	"./symbol_2.png": "727a",
	"./symbol_3.png": "95b8",
	"./symbol_4.png": "6672",
	"./symbol_5.png": "583b",
	"./symbol_6.png": "efd6",
	"./symbol_7.png": "62b7",
	"./symbol_8.png": "517a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "66a8";